import React, { useState, useEffect } from "react";
import { Router } from "react-router-dom";
import "./_assets/_scss/app.scss";
import { Provider } from "react-redux";
import { store, persistor } from "./_redux/_store";
import { history } from "./_redux/_store/history";
import { PersistGate } from "redux-persist/integration/react";
import Header from "./_partials/header";
import FullWidthLayout from "./_layout/fullWidthLayout";
import MainLayout from "./_layout/mainLayout";
import "../src/plugins/axiosDefaults.js";
import { useDispatch } from 'react-redux'
import {
  setBreadcrumb, setBreadcrumbSearch
} from './_redux/_actions/breadcrumbAction';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { useLogin } from "../src/config/useLogin.js";

const App = () => {
  const [error, setError] = useState(null);
  const [errorInfo, setErrorInfo] = useState(null);
  const [appLocation, setAppLocation] = useState("");
  const { instance , accounts } = useMsal();
  const { login } = useLogin();

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    if (window.location.host === "localhost:3000/anomalyexpertui") {
      setAppLocation(pathArray[1]);
    } else {
      setAppLocation(pathArray[2]);
    }
    if (window.location.pathname === '/anomalyexpertui/') {
        history.push('')
    } 
    // else if (window.location.pathname === '/') {
    //     history.replace('/')
    // } 
    else {
        let a = window.location.href.substring(
            window.location.href.lastIndexOf('/') + 1
        )
        history.replace(a)
    }

    localStorage.setItem('baseURL', process.env.NODE_ENV)
  }, []);

  useEffect(() => {
    setError(error);
    setErrorInfo(errorInfo);
  },[error, errorInfo])

  return (
    <Provider store={store}>
      <div className="App" id="anomalyExpertContainer">
        <Router history={history}>
          <PersistGate persistor={persistor}>
            <AuthenticatedTemplate>
              <Header />
              <BreadcrumbDispatch />
            </AuthenticatedTemplate>
            {appLocation === "" || appLocation === "/" ? (
              <FullWidthLayout />
            ) : (
              <MainLayout />
            )}
          </PersistGate>
        </Router>
      </div>
    </Provider>
  );
};

export default App;

export const BreadcrumbDispatch = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    dispatch(setBreadcrumb(pathArray));
    if (window.location.search) {
      dispatch(setBreadcrumbSearch(window.location.search.split("&")));
    }
  }, [dispatch]);

  return null;
}
